import { Emitter } from "pixi-particles";
import { Culture } from "../Data/Culture";
import { NoteParticleSystem } from "./NoteParticleSystem";

export class CultureSwitchParticleBurst extends NoteParticleSystem {
    constructor(pCulture: Culture) {
        super(pCulture);

        this._emitter = new Emitter(this, this.getTexturesForCulture(pCulture), {
            alpha: {
                list: [
                    { value: 1, time: 0 },
                    { value: 1, time: 0.5 },
                    { value: 0, time: 1 },
                ],
                isStepped: false,
            },
            color: {
                list: [
                    { value: "#ffffff", time: 0 },
                    { value: "#ffffff", time: 1 },
                ],
            },
            scale: {
                list: [
                    { value: 0.8, time: 0},
                    { value: 1.0, time: 1},
                ],
                isStepped: false,
            },
            speed: {
                list: [
                    { value: 220, time: 0 },
                    { value: 220, time: 1 },
                ],
                isStepped: false,
            },
            startRotation: { min: 270, max: 270 },
            noRotation: false,
            rotationSpeed: { min: -100, max: 100 },
            lifetime: { min: 0.8, max: 1 },
            frequency: 0.01,
            emitterLifetime: 0.5,
            maxParticles: 100,
            pos: { x: 0, y: 0 },
            spawnType: "burst",
            particlesPerWave: 1,
            particleSpacing: 0,
            angleStart: 0,
        });

        this.stopEmitting();
    }

}
